module.exports = __webpack_public_path__ + "img/glass.0962b79d.png";